import useCreate from "./create";
import useView from "./view"
import useEdit from "./edit"
import useEvaluate from "./evaluate"
import usHistory from "./history"
import usHelp from "./help"

const useProcess = () => {
  return { useView, useCreate, useEdit,useEvaluate, usHistory, usHelp };
};

export default useProcess;